import { FormAtylBase } from '../../form-atyl-base'

export class AtylAgrement extends FormAtylBase<string> {
	controlType = 'agrement';
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
